   <template>
  <div>
    <div class="newheader">
      <div class="logImgs-title">
        <div class="logImgstitlebox">
          <img src="@/assets/u2.png" class="logImgs" />
          <div class="headerText" style="color:#fff;margin-left:5px">
            <div class="headerTexthed">{{biaoTi}}</div>
            <div class="headerTextbot">{{ englishBiaoTi }}</div>
          </div>
        </div>
      </div>

      <!-- 右侧登录 -->
      <transition name="slide-right">
        <div class="logsuspend">
          <ul class="logsupendul" v-if="backflag==true">
            <li
              class="logsupendli"
              @mouseenter="changeImageSrc(1, 'hover')"
              @mouseleave="changeImageSrc(1, '')"
              @click.stop="clickBtnlist('login')"
              v-if="!tokenn"
            >
              <div class="logsupendli-center">
                <img :src="prevImg01" alt />
                <span>登录</span>
              </div>
            </li>

            <!-- <li
              class="logsupendli"
              @mouseenter="changeImageSrc(2, 'hover')"
              @mouseleave="changeImageSrc(2, '')"
              v-if="!tokenn"
            >
              <div class="logsupendli-center">
                <img :src="prevImg02" alt />
                <span>注册</span>
              </div>
            </li>-->

            <li
              style="height:120px"
              class="logsupendli"
              @mouseenter="changeImageSrc(5, 'hover')"
              @mouseleave="changeImageSrc(5, '')"
              v-if="tokenn && !isManager"
            >
              <div class="logsupendli-center" @click="personCenter()">
                <img :src="person.photo" alt style="width:40px;height:40px;border-radius: 50%;" />
                <div style="font-size:12px;margin-top:13px">{{person.name}}</div>
                <span style="font-size:10px">个人中心</span>
              </div>
            </li>

            <!-- <el-popover placement="left" trigger="hover">
              <img src="@/assets/APP二维码.png" style="width:130px;height:130px" />

              <li
                class="logsupendli"
                slot="reference"
                @mouseenter="changeImageSrc(3, 'hover')"
                @mouseleave="changeImageSrc(3, '')"
              >
                <div class="logsupendli-center">
                  <img :src="prevImg03" alt />
                  <span>移动APP</span>
                </div>
              </li>
            </el-popover>-->

            <li
              class="logsupendli"
              @mouseenter="changeImageSrc(4, 'hover')"
              @mouseleave="changeImageSrc(4, '')"
              @click="goSystiem()"
              v-if="tokenn && isManager"
            >
              <div class="logsupendli-center">
                <img :src="prevImg04" alt />
                <span>{{person.name}}</span>
              </div>
            </li>
            <li
              class="logsupendli"
              @mouseenter="changeImageSrc(5, 'hover')"
              @mouseleave="changeImageSrc(5, '')"
              @click="goOut()"
              v-if="tokenn"
            >
              <div class="logsupendli-center">
                <img :src="prevImgexit" alt />
                <span>退出登录</span>
              </div>
            </li>
            <li
              class="logsupendli"
              @mouseenter="changeImageSrc(8, 'hover')"
              @mouseleave="changeImageSrc(8, '')"
              @click="feedBack()"
            >
              <div class="logsupendli-center">
                <img :src="prevImg08" alt />
                <span>意见反馈</span>
              </div>
            </li>
            <li
            class="logsupendli"
            v-if="tokenn && isManager"
            @click.stop="toUpFileUrl"
            >
              <div class="logsupendli-center">
                <i style="font-size:36px;color:#266EED;" class="el-icon-upload"></i>
                <span>文件上传</span>
              </div>
            </li>
            <div
              class="logsupendli logsupendli7"
              @mouseenter="changeImageSrc(6, 'hover')"
              @mouseleave="changeImageSrc(6, '')"
              @click="takeback()"
            >
              <div class="logsupendli-center">
                <img style="width:30px;height:30px;" :src="prevImg06" alt />
              </div>
            </div>
          </ul>
          <div @click="takeback()" v-if="backflag==false" class="jiantou">
            <img class="arrowsleft" src="@/assets/images/home/chevron-back-outline.svg" />
          </div>
        </div>
      </transition>

      <!-- 左侧浮动 -->
      <div class="sildLeft" v-if="flgIndex && colocList.length !=0">
        <div
          class="sidBoximg"
          v-for="(items,index) in colocList "
          :key="index"
          v-if="!items.isroll"
          v-on:mouseenter="showDialog(index,items)"
          v-on:mouseleave="hideDialog(index,items)"
        >
          <a :href="items.linkUrl" target="_blank">
            <img class="sidBoximgbg" :src="items.imgurl" alt />
          </a>
          <img @click="clidColse(index)" class="sidimgs" :src="items.colserimg" alt />
        </div>
      </div>

      <!-- </div> -->
      <div class="navtabOne" :data-theme="$store.getters.dataTheme">
        <ul class="tatHeaderOne">
          <li
            class="litab"
            v-for="(item,index) in navss"
            :key="index"
            @click="TabIndexType(index,item.path,item)"
            :class="{litabactive:indexactive==item.num}"
          >
            <div class="tabstext">{{item.title}}</div>
          </li>
        </ul>
        <!-- <div style="margin-right:10px" v-if="flgIndex">
          <el-input
            @keyup.enter.native="searcha"
            size="large"
            type="text"
            placeholder="全文检索"
            v-model="keyworks"
            class="input-with-select"
          >
            <el-button
              slot="append"
              @click="searcha"
              icon="el-icon-search"
              style="background: #fff;border-top-left-radius: 0px;border-bottom-left-radius: 0px;height: 40px; font-size: 16px;"
            ></el-button>
          </el-input>
        </div> -->
      </div>
    </div>

    <el-dialog :visible.sync="loginVisible" width="28%" :before-close="handleClose">
      <login @closeAlert="handleClose"></login>
    </el-dialog>

    <el-dialog :visible.sync="feedBackDialog" title="意见反馈" width="700px" class="dialog-mini">
      <el-form :model="feedBackFrom" :rules="feedBackRules" ref="feedBackFrom" label-width="100px">
        <el-form-item label="类别" prop="type">
          <el-radio-group v-model="feedBackFrom.type">
            <el-radio :label="1">使用意见</el-radio>
            <el-radio :label="2">应用需求</el-radio>
            <el-radio :label="3">系统bug</el-radio>
            <el-radio :label="4">其它问题</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用意见" prop="idea">
          <el-input type="textarea" v-model="feedBackFrom.idea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <div style="display: flex">
            <el-upload
              ref="myupload"
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="activityFileHandleRemove"
              :on-success="activitysuccess"
              multiple
              v-model="feedBackFrom.fileUrl"
              :file-list="fileLists"
              accept=".doc, .docx, .mp4, .avi, .jpg, .jpeg, .png, .svg, .gif"
              :limit="1"
              :show-file-list="false"
            >
              <!-- accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" -->

              <el-button type="primary">上传</el-button>
            </el-upload>
            <el-button
              style="margin-left: 10px"
              v-if="feedBackFrom.fileUrl"
              @click="activityFileHandleLook"
            >查看</el-button>
            <el-button v-if="feedBackFrom.fileUrl" @click="activityFileHandleRemove">移除</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feedBackDialog = false">取 消</el-button>
        <el-button type="primary" @click="addfeedBack">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getInfo, removeInfo } from '@/utils/auth';
import Login from '@/views/login/Login';
import piaoC from '@/components/piaoc/index';
import piaoC2 from '@/components/piaoc/index2';
import * as clientshomeApi from '@/api/clientshome/index';
import elDragDialog from '@/directive/el-dragDialog';
import * as message from '@/api/message/index';
export default {
  props: ['paths'],
  props: {
    getList: {
      type: Function,
      default: null,
    },
  },
  components: { Login, piaoC, piaoC2 },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      biaoTi: localStorage.getItem('biaoti'),
      englishBiaoTi: localStorage.getItem('englishBiaoTi'),
      fileLists: [],
      nowIndex: 0,
      autoplayVideo: true,
      json: {
        src: 'https://www.ssdfz.net/ImageFiles/20180419130336830.jpg',
        url: 'http://www.baidu.com',
        left: 100,
        top: 400,
        colserimg: require('@/assets/index/colosemr.png'),
      },
      json2: {},
      json3: {},
      json4: {},
      showView: true,
      showView2: true,
      showView3: true,
      showView4: true,
      flgIndex: true,
      nohome: Boolean(sessionStorage.getItem('nohome')),
      colocList: [],
      nodownload: false,

      isPlay: false,
      isIn: false,
      autoplay: false,
      isviposter: true,
      oldIndex: 0,
      carousels: [],
      listQuerya: { Name: '' },
      bannerUrl: require('@/assets/newIndex/bg03.jpg'),
      loginVisible: false,
      keyworks: localStorage.getItem('keyworks'),
      prevImg01: require('@/assets/newIndex/lg.png'),
      prevImg02: require('@/assets/newIndex/reg.png'),
      prevImg03: require('@/assets/newIndex/ap.png'),
      prevImg04: require('@/assets/newIndex/mgt.png'),
      prevImg08: require('@/assets/newIndex/viewIcon.png'),
      prevImgexit: require('@/assets/newIndex/exit.png'),
      prevImg06: require('@/assets/newIndex/arrawactive.png'),
      tokenn: getInfo('tokens'), // 判断是否登录
      moovflag: false, //当鼠标移入手机app是显示左边二维码
      backflag: true,
      headerImg: require('@/assets/newIndex/hederImg.png'),
      criminalImg: require('@/assets/newIndex/u31088.jpg'),
      indexactive: 0,
      twoWebsite: [],
      navs: [
        {
          path: '/home',
          title: '首页',
          num: 0,
        },
        {
          path: '/mooc',
          title: '微警校',
          num: 1,
        },
        {
          path: '/sourceslist',
          title: '资源中心',
          num: 2,
        },
        {
          path: '/exam',
          title: '考试中心',
          num: 3,
        },
        {
          path: '/train',
          title: '调训中心',
          num: 4,
        },
        {
          path: '/diaoa',
          title: '教官库',
          num: 5,
        },
        {
          path: '/diaoy',
          title: '问卷测评',
          num: 6,
        },
        {
          path: '/certificate',
          title: '电子证书',
          num: 7,
        },
        {
          path: '/dowload',
          title: '下载中心',
          num: 8,
        },
      ],
      navss: [
        {
          path: '/home',
          title: '首页',
          num: 0,
        },
      ],
      colserimg: require('@/assets/index/colosemr.png'),
      isManager: false,
      feedBackDialog: false,
      feedBackFrom: {
        type: null,
        idea: null,
        status: 0,
        fileUrl: null,
        createId: this.$store.state.User.ids ? this.$store.state.User.ids : 0,
        createName: '',
      },
      feedBackRules: {
        type: [{ required: true, message: '请选择类别', trigger: 'change' }],
        idea: [{ required: true, message: '请输入反馈意见', trigger: 'blur' }],
      },
      person:getInfo('infos') ? JSON.parse(getInfo('infos')) : '',
    };
  },
  watch: {
    paths: {
      handler: function (val, oldVal) {
        this.getRouterName(this.paths);
      },
    },
    info_tirgger: function () {
      this.person = JSON.parse(getInfo('infos'));
      this.isManager =this.person.isManger
      this.tokenn=this.person.token
    },
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
    info_tirgger() {
      return this.$store.state.User.infos;
    },
  },

  destroyed() {
    this.flgIndex = false;
  },
  created() {
    // this.getlunboimg();
    window.clikLogin = this.clikLogin;
    if (this.tokenn) {
      //判断是否登录，是的或取值，没登录取值会报错
      this.person = JSON.parse(getInfo('infos'));
      this.isManager = JSON.parse(this.$store.state.User.infos).isManger;
    }
  

  },
  mounted() {
    this.getPathTab();
    this.getRouterName(this.$route.path);
    this.getcolocList();
  },
  methods: {
    addfeedBack() {
      this.$refs.feedBackFrom.validate((valid) => {
        if (valid) {
          message.addUserFeedback(this.feedBackFrom).then((res) => {
            this.$message.success('成功');
            this.feedBackDialog = false;
            this.$refs.feedBackFrom.resetFields();
          });
        }
      });
    },
    activityFileHandleLook() {
      if (this.feedBackFrom.fileUrl == '') {
        this.$notify({
          title: '失败',
          message: '没有文件可查看',
          type: 'warning',
        });
      } else {
        //下载文件
        window.open(this.feedBackFrom.fileUrl);
      }
    },
    activityFileHandleRemove(file, fileList) {
      this.feedBackFrom.fileUrl = '';
      this.$nextTick(() => {
        this.$refs.myupload.clearFiles();
      });
    },
    activitysuccess(response, file, fileList) {
      this.feedBackFrom.fileUrl = response.result;
    },
    //点击意见反馈
    feedBack() {
      this.fileLists = [];
      this.feedBackFrom = {
        type: null,
        idea: null,
        status: 0,
        fileUrl: null,
        createId: this.$store.state.User.ids ? this.$store.state.User.ids : 0,
      };
      this.feedBackDialog = true;
    },
    getPathTab() {
      this.twoWebsite = localStorage.getItem('twoWebsite').split(',');
      // console.log(this.twoWebsite);
      for (var i = 0; i < this.twoWebsite.length; i++) {
        for (var j = 0; j < this.navs.length; j++) {
          if (this.twoWebsite[i] == this.navs[j].title) {
            this.navss.push(this.navs[j]);
          }
        }
      }
      this.navss.sort(this.compare('num'));
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    closeView(val) {
      this.showView = false;
    },
    closeView2(val) {
      this.showView2 = false;
    },
    closeView3(val) {
      this.showView3 = false;
    },
    closeView4(val) {
      this.showView4 = false;
    },
    getcolocList() {
      clientshomeApi.getFloatPage().then((res) => {
        this.colocList = res.result;
        if(this.colocList.length>0)
        {
        this.colocList.forEach((item, index) => {
          item.colserimg = require('@/assets/index/colosemr.png');
          item.left = item.zx;
          item.top = item.zy;
        });
        // this.json = this.colocList[0];
        if (this.colocList.length >= 2) {
          this.json2 = this.colocList[1];
        }
        if (this.colocList.length >= 3) {
          this.json3 = this.colocList[2];
        }
        if (this.colocList.length >= 4) {
          this.json4 = this.colocList[3];
        }
        }
      });
    },
    showDialog(index, items) {
      items.colserimg = require('@/assets/index/coloract.png');
      // this.colocList[index].colserimg = require('@/assets/index/coloract.png');
    },
    hideDialog(index, items) {
      items.colserimg = require('@/assets/index/colosemr.png');
      // this.colocList[index].colserimg = require('@/assets/index/colosemr.png');
    },
    clidColse(index) {
      this.colocList.splice(index, 1);
    },
    clidGo(items) {
      this.$router.push(items.linkUrl);
    },

    // 获取轮播图
    // getlunboimg() {
    //   let data = { status: 1 };
    //   clientshomeApi.CmsPropagateList(data).then((res) => {
    //     this.carousels = res.result;
    //   });
    // },

    // 轮播图片跳转详情
    gotdetailswper(){
      let activeIndex = this.$refs.carousel.activeIndex;
      let carousels = this.carousels;
      if (carousels[activeIndex].type == true) {
        if (activeIndex == 0) {
          this.$router.push('/centerabstract');
        } else {
          this.$router.push('/index/slideshowdetail');
        }
      }
    },
    //获取走马灯的索引
    getIndex(nowIndex, oldIndex) {
      this.autoplayVideo = true;
      //此时需要暂停上个视频并把时间归零，否则影响对当前视频的监听逻辑
      // console.log(nowIndex, oldIndex);
      if (nowIndex == 1) {
        //进入视频页面就给添加封面
        // console.log('进来');
        this.isviposter = true;
      }
      if (this.carousels[nowIndex].isvideo == true) {
        this.$nextTick(function () {
          let myVideo = this.$refs['videoto' + nowIndex];
          this.nowIndex = nowIndex;
          myVideo[0].pause();
          myVideo[0].currentTime = 1;
          this.isPlay = false;
        });
      }
      if (this.carousels[oldIndex].isvideo == true) {
        this.$nextTick(function () {
          let myVideo = this.$refs['videoto' + oldIndex];
          myVideo[0].pause();
        });
      }
    },
    // 点击屏幕播放
    suspend() {
      let myVideo = this.$refs['videoto' + this.nowIndex];
      if (this.isPlay) {
        myVideo[0].play();

        this.isPlay = false;
        this.isviposter = false; //隐藏封面
      } else {
        myVideo[0].pause();
        this.isPlay = true;
      }
    },
    // 点击播放
    playVideock() {
      this.autoplayVideo = false;
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs['videoto' + this.nowIndex];
      myVideo[0].play();
      this.isPlay = true;
      this.isviposter = false;
    },
    // 点击暂停
    pauseVideo() {
      this.autoplayVideo = false;
      let myVideo = this.$refs['videoto' + this.nowIndex];
      myVideo[0].pause();
      this.isPlay = false;
    },
    keySearch() {},

    //搜索
    searcha() {
      if (this.keyworks == null || this.keyworks == '') {
        this.$message({
          message: '提示,搜索不能为空',
          type: 'warning',
        });
      }
      // else if (this.keyworks.length < 2) {
      //   this.$message({
      //     message: '提示,至少需要两个字符',
      //     type: 'warning',
      //   });
      // }
      else {
        localStorage.setItem('keyworks', this.keyworks);
        localStorage.setItem('Kroute', this.$route.path);
        if (this.$route.path == '/search') {
          this.getList();
        } else {
          this.$router.push({
            path: '/search',
            query: {},
          });
        }
      }
    },
    addFavorite() {
      var url = window.location;
      var title = document.title;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('360se') > -1) {
        alert('由于360浏览器功能限制，请按 Ctrl+D 手动收藏！');
      } else if (ua.indexOf('msie 8') > -1) {
        window.external.AddToFavoritesBar(url, title); //IE8
      } else if (document.all) {
        //IE类浏览器
        try {
          window.external.addFavorite(url, title);
        } catch (e) {
          alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
        }
      } else if (window.sidebar) {
        //firfox等浏览器；
        window.sidebar.addPanel(title, url, '');
      } else {
        alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
      }
    },
    clikLogin() {
      this.loginVisible = !this.loginVisible;
    },
    handleClose() {
      this.loginVisible = false;
    },
    getRouterName(roterNmae) {
      switch (roterNmae) {
        case '/home':
          this.flgIndex = true;
          this.indexactive = 0;
          this.$store.commit('SET_TABQIT', this.indexactive);

          break;
        case '/mooc':
          this.flgIndex = false;
          this.indexactive = 1;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/sourceslist':
          this.flgIndex = false;

          this.indexactive = 2;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/exam':
          this.flgIndex = false;
          this.indexactive = 3;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/train':
          this.flgIndex = false;
          this.indexactive = 4;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/diaoa':
          this.flgIndex = false;
          this.indexactive = 5;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/certificate':
          this.flgIndex = false;
          this.indexactive = 7;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/dowload':
          this.flgIndex = false;
          this.indexactive = 8;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/diaoy':
          this.flgIndex = false;
          this.indexactive = 6;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
      }
    },
    TabIndexType(index, path, item) {
      // console.log(path);
      this.indexactive = item.num;
      this.$router.push(path);

      if (path == '/home') {
        this.flgIndex = true;
      } else {
        this.flgIndex = false;
      }
    },
    //点击个人中心跳转到页面
    personCenter() {
      this.$router.push('/personCenter/personhome');
    },
    // 后台管理
    goSystiem(){
      let toke = getInfo('tokens');
      if(!toke){
        window.location.reload();
        return false
      }
      let managerUrl = localStorage.getItem('managerUrl');
      window.open(`${managerUrl}/index?token=` + toke);

      // window.open('http://localhost:8087/index?token=' + toke);
    },
    // 退出功能
    goOut() {
      var _this = this;
      _this.$confirm('确认退出吗?', '提示', {}).then(() => {
        _this.$store.dispatch('logout').then(() => {
          _this.$router.push('/home');
          window.location.reload();
        });
      });
    },
    //点击缩回和放出登录栏
    takeback() {
      this.backflag = !this.backflag;
    },
    // 点击登录
    clickBtnlist(val) {
      this.$emit(val);
      this.clikLogin();
    },
    // 点击切换图片
    changeImageSrc(key, way) {
      let hoverStr = way === 'hover' ? 'active' : '';
      switch (key) {
        case 1:
          this.prevImg01 = require(`@/assets/newIndex/lg${hoverStr}.png`);
          break;
        case 2:
          this.prevImg02 = require(`@/assets/newIndex/reg${hoverStr}.png`);
          break;
        case 3:
          this.prevImg03 = require(`@/assets/newIndex/ap${hoverStr}.png`);
          this.moovflag = true;
          break;
        case 4:
          this.prevImg04 = require(`@/assets/newIndex/mgt${hoverStr}.png`);
          this.showFlag = false;
          break;
        case 5:
          this.prevImg05 = require(`@/assets/images/home/packup${hoverStr}.png`);
          this.showFlag = false;
          break;
        case 8:
          this.prevImg08 = require(`@/assets/newIndex/viewIcon${hoverStr}.png`);
          break;
      }
      if (way == '') {
        this.moovflag = false;
      }
    },
    SetHome(obj, url) {
      try {
        obj.style.behavior = 'url(#default#homepage)';
        obj.setHomePage(url);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              'UniversalXPConnect'
            );
          } catch (e) {
            alert(
              "抱歉，此操作被浏览器拒绝！\n\n请在浏览器地址栏输入“about:config”并回车然后将[signed.applets.codebase_principal_support]设置为'true'"
            );
          }
        } else {
          alert(
            '抱歉，您所使用的浏览器无法完成此操作。\n\n您需要手动将【' +
              url +
              '】设置为首页。'
          );
        }
      }
    },
    AddFavorite(title, url) {
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        try {
          window.sidebar.addPanel(title, url, '');
        } catch (e) {
          alert(
            '抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加'
          );
        }
      }
    },
    //跳转文件上传
    toUpFileUrl(){
      this.$router.push({path:'/home/upFileWork'});
    }
  },
};
</script>


<style lang="scss" scoped>
.newheader {
  width: 100%;
  .logImgs-title {
    height: 130px;
    color: #fff;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 34px;
    padding-top: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .logImgstitlebox {
      height: 130px;
      // width: 818px;
      display: flex;
      align-items: center;
      .logImgs {
        height: 96px;
        width: auto;
        margin-right: 44px;
      }
      .headerText {
        flex: 1;
      }
      .headerTexthed {
        font-family: '楷体';
        font-weight: 700;
        font-style: normal;
        font-size: 60px;
        line-height: 87px;
        color: #ffffff;
        letter-spacing: 18px;
        white-space: nowrap;
      }
      .headerTextbot {
        position: relative;
        font-weight: 500;
        font-style: normal;
        font-size: 28px;
        line-height: 42px;
        letter-spacing: 2px;
        white-space: nowrap;
      }
    }
  }

  .serch-collect {
    .serchbox {
      display: flex;
      align-items: center;
      height: 30px;
      input {
        width: 180px;
        height: 30px;
        border-radius: 15px 0 0 15px;
        padding-left: 10px;
        background-color: #fff;
      }
      .serchboxImg {
        cursor: pointer;
        width: 38px;
        height: 30px;
        background-color: #fff;
        border-radius: 0 15px 15px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 15px;
          width: 15px;
        }
      }
      .headerSys {
        text-align: center;
        color: #fff;
        font-size: 14px;
        margin-left: 20px;
        &:hover {
          cursor: pointer;
        }
        img {
          height: 20px;
          width: 20px;
        }
      }
    }
  }

  .navtabOne {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 68px;
    padding: 15px 0 23px 0;
    background-color: #fff;
    display: flex;
    .tatHeaderOne {
      display: flex;
      flex-wrap: wrap;
      color: #000;
      padding-left: 30px;
      flex: 1;
      .litab {
        width: 105px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 400;
        line-height: 30px;
        position: relative;

        &:hover:after {
          content: '';
          display: block;
          position: absolute;
          bottom: -10px;
          left: 50%;
          right: 0;
          margin-left: -20px;
          height: 4px;
          width: 44px;
          background: transparent;
        }
        &:hover {
          cursor: pointer;
        }
      }

      .litabactive{
        font-weight:700;
      }
      .litabactive:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -10px;
        left: 50%;
        right: 0;
        margin-left: -20px;
        height: 4px;
        width: 44px;
        background: #4192ff;
      }
      .tabstext {
        margin-left: 5px;
      }
    }
  }
}

// 右侧登录
.logsuspend {
  // position: fixed;
  position: absolute;
  // right: 50px;
  right: 259px;
  // top: 140px;
  top: 211px;
  z-index: 30;

  .logsupendul {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgb(242 242 242 / 99%);
    .logsupendli {
      width: 80px;
      padding: 5px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      .logsupendli-center {
        text-align: center;
        width: 100%;
        img {
          display: block;
          width: 40px;
          height: 40px;
          margin: 0 auto;
        }
        span {
          display: block;
          font-size: 14px;
          margin-top: 2px;
        }
      }
      &:hover {
        color: #fff;
        background: #1492ff;
        cursor: pointer;
      }
    }
    .logsupendli7 {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      border: 0;
      height: 50px;
      background-color: #7f7f7f;
      border-radius: 0 0 5px 5px;
      img {
        width: 28px;
        height: 28px;
      }
    }
  }
  .arrowsleft {
    width: 24px;
    height: 62px;
    position: absolute;
    left: -24px;
    top: 50%;
    margin-top: auto;
  }
}
.slide-right-enter,
.slide-right-leave-active {
  transform: translateX(120px);
}
.slide-right-leave-active,
.slide-right-enter-active {
  transition: all 0.6s 0.6s cubic-bezier(0.33, 0.25, 0.33, 1);
}
.jiantou > img {
  background-color: #ccc;
  border-radius: 5px;
}
.jiantou > img:hover {
  cursor: pointer;
  background-color: rgb(108, 176, 231);
}
.phoneapp {
  width: 200px;
  height: 200px;
  background-image: url('../../assets/APP二维码.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #333;
  position: fixed;
  top: 21%;
  left: 83%;
}

.play-btn {
  font-size: 60px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
//进度条
video::-webkit-media-controls-timeline {
  display: none;
}
.bannerbox {
  position: relative;
  margin-top: 10px;
}

.banner {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;

  .el-carousel {
    .el-carousel__container {
      position: relative;
      height: 400px !important;
      .carousel-inner {
        width: 1200px;
        height: 400px !important;
        img {
          width: 1200px;
          object-fit: fill;
          height: 400px;
        }
      }
    }
  }
}
</style>
<style scoped>
.sildLeft {
  position: fixed;
  left: 4%;
  top: 140px;
}
/deep/.el-carousel__container {
  height: 400px;
}

/* /deep/.el-dialog__header {
  padding: 0px !important;
} */

/deep/.el-dialog__body {
  padding: 10px 0 20px 0 !important;
}

.input-with-select >>> .el-input__inner {
  width: 200px;
  color: #fff !important;
  height: 40px;
  background-color: #1492ff;
  border-radius: 5px 0 0 5px;
}
.sidBoximg {
  width: 200px;
  height: 100px;
  margin-bottom: 10px;
  position: relative;
}

.sidimgs {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.sidBoximg .sidBoximgbg {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
</style>

<style scoped>
/deep/.el-input__inner {
  background-color: #fff;
}

/deep/input::-webkit-input-placeholder {
  /* color: #fff; */
  font-size: 16px;
}
/deep/.el-select .el-input .el-select__caret {
  color: #fff;
}
/deep/.el-dialog__header {
  padding: 20px;
  padding-bottom: 10px;
}
</style>